import React from 'react';
import useProperty from '../../hooks/useProperty';
import usePropertyPath from '../../hooks/usePropertyPath';
import styled from 'styled-components';
import { CheckBoxPanel } from 'styles/v2/Styles.styled';
import WizardCheckboxComponent from 'components/v2/epd-wizard-inputs/WizardCheckbox';
import WizardTextAreaControlledComponent from 'components/v2/epd-wizard-inputs/WizardTextAreaControlled';

const LcaDatabasesListRendererOther: React.FC = () => {
  const otherLcaDatabaseEnabledPath = usePropertyPath('otherLcaDatabaseEnabled');
  const otherLcaDatabaseEnabled = useProperty<string | null>(otherLcaDatabaseEnabledPath);

  const otherLcaDatabaseNamePath = usePropertyPath('otherLcaDatabaseName');
  const otherLcaDatabaseName = useProperty<string>(otherLcaDatabaseNamePath);

  return (
    <OtherContainer>
      <CheckBoxPanel style={{ marginTop: 0 }}>
        <WizardCheckboxComponent
          inputId="isOtherLcaDatabaseUsedAsDatasource"
          label="Other database"
          name="isOtherDatabaseUsedAsDatasource"
          value={otherLcaDatabaseEnabled.value === 'Yes'}
          onChanged={(_: string, newValue: boolean) => otherLcaDatabaseEnabled.setValue(newValue ? 'Yes' : 'No')}
          disabled={otherLcaDatabaseEnabled.isDisabled}
        />
      </CheckBoxPanel>

      {otherLcaDatabaseName.isVisible && (
        <WizardTextAreaControlledComponent
          label="Other database description"
          placeholder="Type here"
          name="otherDatabaseUsedAsDatasourceDescription"
          value={otherLcaDatabaseName.value}
          onChange={(e) => otherLcaDatabaseName.setValue(e.target.value)}
          onChanged={() => {}}
          error={otherLcaDatabaseName.errorMessage}
        />
      )}
    </OtherContainer>
  );
};

export default LcaDatabasesListRendererOther;

const OtherContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 16px;

  & .p-checkbox {
    width: 16px;
    height: 16px;
  }

  & .p-checkbox .p-checkbox-box {
    width: 14px;
    height: 14px;
    align-self: center;
  }
`;
